export default {
    methods: {
        isFieldEmail(field) {
            return this.isFieldOfType(field, 'email');
        },
        isFieldInput(field) {
            return this.isFieldOfType(field, 'input');
        },
        isFieldUrl(field) {
            return this.isFieldOfType(field, 'url');
        },
        isFieldCheckbox(field) {
            return this.isFieldOfType(field, 'checkbox');
        },
        isFieldCountrySelect(field) {
            return this.isFieldOfType(field, 'countrySelect');
        },
        isFieldDisclaimer(field) {
            return this.isFieldOfType(field, 'disclaimer');
        },
        isVisibleWithEmailFirst(field) {
            return field.visibleWithEmailFirst;
        },
        isFieldEventSessions(field) {
            return this.isFieldOfType(field, 'eventSessions');
        },
        isFieldFieldset(field) {
            return this.isFieldOfType(field, 'fieldset');
        },
        isFieldHidden(field) {
            return this.isFieldOfType(field, 'hidden');
        },
        isFieldMessage(field) {
            return this.isFieldOfType(field, 'message');
        },
        isFieldMultiCheckbox(field) {
            return this.isFieldOfType(field, 'multiCheckbox');
        },
        isFieldPhone(field) {
            return this.isFieldOfType(field, 'phone');
        },
        isFieldSelect(field) {
            return this.isFieldOfType(field, 'select');
        },
        isFieldStateSelect(field) {
            return this.isFieldOfType(field, 'provinceStateSelect');
        },
        isFieldSubmitButton(field) {
            return this.isFieldOfType(field, 'submit');
        },
        isFieldTextarea(field) {
            return this.isFieldOfType(field, 'textarea');
        },
        isFieldOfType(field, type) {
            return field.type === type;
        },
        isFieldValidForSubmission(field) {
            return field.userInput !== null
                && typeof (field.userInput) !== 'undefined'
                && field.isValid
                && !field.ignore
                && field.state.connected
                && field.name;
        }
    }
}